/* unplugin-vue-components disabled */export default {
  emits: ['update:modelValue'],
  props: {
    modelValue: {
      type: [String, Object, Array],
      default: ''
    },
    type: {
      type: String,
      default: 'datetime'
    },
    format: {
      type: String,
      default: 'yyyy-MM-dd HH:mm:ss'
    },
    options: {
      type: Object,
      default: {}
    },
    placeholder: {
      type: String,
      default: '请选择活动时间'
    }
  },
  data: function data() {
    return {
      time: undefined
    };
  },
  watch: {
    modelValue: {
      handler: function handler(val) {
        this.time = val;
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    handleChange: function handleChange(val) {
      if (val[0] == val[1] && val[0] === '') val = [];
      if (this.type === 'datetimerange') {
        var _end = (val[1] || '').split(' ');
        if (_end[1] === '00:00:00') {
          val[1] = _end[0] + ' 23:59:59';
        }
      }
      this.time = val;
      this.$emit('update:modelValue', val);
    }
  }
};